import { type FC, type ReactElement } from 'react'
import { FormattedMessage, type MessageDescriptor } from 'react-intl'

const odsModalSteps: ReactElement<MessageDescriptor>[] = [
  <FormattedMessage
    id="pdp.buyboxwithvariants.odsModal.process.step1"
    key="pdp.buyboxwithvariants.odsModal.process.step1"
  />,
  <FormattedMessage
    id="pdp.buyboxwithvariants.odsModal.process.step2"
    key="pdp.buyboxwithvariants.odsModal.process.step2"
  />,
  <FormattedMessage
    id="pdp.buyboxwithvariants.odsModal.process.step3"
    key="pdp.buyboxwithvariants.odsModal.process.step3"
  />,
]

export const ProductPageOdsDialogOnlineDoctorSectionSteps: FC = () => (
  <section id="ods-steps">
    <h3 className="font-medium">
      <FormattedMessage id="pdp.buyboxwithvariants.odsModal.tabs.tab1.stepsHeader" />
    </h3>
    <ol className="list-numbered-hexagon font-normal text-dark-primary-max">
      {odsModalSteps.map((item) => (
        <li className="mt-5" key={item.props.id}>
          {item}
        </li>
      ))}
    </ol>
  </section>
)
